module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-193.8650e3b7.svg";